import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ProductDetail from '../components/ProductDetail';

// 예시: humanProducts, animalProducts 데이터 임포트
import {
  human_products_with_slug as human_products,
  IMAGE_BASE_PATH as HUMAN_IMAGE_BASE_PATH,
} from '../assets/data/human_prod';
import {
  animal_products_with_slug as animal_products,
  IMAGE_BASE_PATH as ANIMAL_IMAGE_BASE_PATH,
} from '../assets/data/animal_prod';

export default function Product() {
  // const { id } = useParams();
  const { slug } = useParams(); // id 대신 slug를 받음
  const location = useLocation();

  // URL 경로에서 카테고리(human 또는 animal) 확인
  const isHumanProduct = location.pathname.includes('/human/');

  // 카테고리에 따라 적절한 제품 데이터와 이미지 경로 선택
  const products = isHumanProduct ? human_products : animal_products;
  const imagePath = isHumanProduct
    ? HUMAN_IMAGE_BASE_PATH
    : ANIMAL_IMAGE_BASE_PATH;

  // slug로 제품 찾기
  const product = products.find((p) => p.slug === slug);

  // // 두 데이터 합치기 (필요에 따라 분리 가능)
  // const allProducts = [
  //   ...human_products.map((p) => ({
  //     ...p,
  //     image: `${HUMAN_IMAGE_BASE_PATH}${p.image}`,
  //   })),
  //   ...animal_products.map((p) => ({
  //     ...p,
  //     image: `${ANIMAL_IMAGE_BASE_PATH}${p.image}`,
  //   })),
  // ];

  // // 선택된 제품 데이터에서 id에 해당하는 제품 찾기
  // const product = products.find((p) => p.id === id);

  // 제품 이미지 경로 완성
  const productWithImage = product
    ? { ...product, image: `${imagePath}${product.image}` }
    : null;

  // 돌아갈 경로 결정
  const returnPath = isHumanProduct ? '/human' : '/animal';

  return <ProductDetail product={productWithImage} returnPath={returnPath} />;
}
